import React from 'react';
import { FDStack } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  Section,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedPostSelectionNextUpActionsStepTemplate/Content/Section';
import { dataAttrs } from 'Helpers/Testing';
import {
  BusinessStatistic,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedPostSelectionNextUpActionsStepTemplate/Content/BusinessStatistics/BusinessStatistic';
import useMobileLayout from 'Hooks/useMobileLayout';
import {
  NextUpInsight,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedPostSelectionNextUpActionsStepTemplate/NextUpInsight';


const ScenarioSelectionRedefinedPostSelectionNextUpActionsStepContent = ({ resource }) => {
  const isMobile = useMobileLayout();
  const sections = resource.attr('sections').resources().list();
  const businessStatistics = resource.attr('businessStatistics')?.resources()?.list() ?? [];

  return (
    <FDStack direction={'column'} alignItems={'center'} spacing={6} width={'100%'} {...dataAttrs('scenario-selection-redefined-wizard-next-up-actions-step-content')}>
      <NextUpInsight resource={resource} />
      <FDStack direction={'column'} spacing={4} width={'100%'} alignItems={'center'}>
        {sections.map((section) => (
          <Section
            key={section.id()}
            sectionResource={section}
            parentResource={resource}
          />
        ))}
      </FDStack>
      {businessStatistics.length > 0 ? (
        <FDStack direction={isMobile ? 'column' : 'row'} justifyContent={'space-between'}>
          {businessStatistics.map((b) => {
            return (
              <BusinessStatistic key={b.id()} resource={b} />
            );
          })}
        </FDStack>
      ) : null}
    </FDStack>
  );
};

ScenarioSelectionRedefinedPostSelectionNextUpActionsStepContent.defaultProps = {};

ScenarioSelectionRedefinedPostSelectionNextUpActionsStepContent.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export { ScenarioSelectionRedefinedPostSelectionNextUpActionsStepContent };
